import { type ComponentType } from "react";

type Props<T = unknown> = {
  fn: () => Promise<{ default: ComponentType<T> }>;
  retriesLeft?: number;
};

const DEFAULT_RETRY_COUNT = 5;
const INTERVAL_TIME = 1000;

export const retryLazyLoad = <T>({
  fn,
  retriesLeft = DEFAULT_RETRY_COUNT,
}: Props<T>): Promise<{ default: ComponentType<T> }> => {
  return fn().catch((error: Error) => {
    return new Promise((resolve, reject) => {
      if (retriesLeft <= 1) {
        reject(error);
        return;
      }
      setTimeout(() => {
        retryLazyLoad({ fn, retriesLeft: retriesLeft - 1 }).then(resolve, reject);
      }, INTERVAL_TIME);
    });
  });
};
